import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import { Core } from "@faire/design-tokens";
import { browserLevelLanguage } from "@faire/help-center-utils/serialized-data/getLocale";
import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
import { getSpacing } from "@faire/web/slate/spacing";
var getIframeElementFromSelector = function getIframeElementFromSelector(selector) {
  var iframe = document.getElementById("web-messenger-container");
  if (iframe) {
    var _iframe$contentDocume;
    var iframeDocument = (_iframe$contentDocume = iframe.contentDocument) !== null && _iframe$contentDocume !== void 0 ? _iframe$contentDocume : iframe.contentWindow ? iframe.contentWindow.document : null;
    return iframeDocument === null || iframeDocument === void 0 ? void 0 : iframeDocument.querySelector(selector);
  }
  return null;
};
export var removeSunCoLogo = function removeSunCoLogo() {
  var sunCoLogo = getIframeElementFromSelector(".logo");
  if (sunCoLogo) {
    sunCoLogo.style.display = "none";
  }
};
export var hideInputField = function hideInputField() {
  var messageInputField = getIframeElementFromSelector("#footer");
  if (messageInputField) {
    messageInputField.style.display = "none";
  }
};
export var showInputField = function showInputField() {
  var messageInputField = getIframeElementFromSelector("#footer");
  if (messageInputField) {
    messageInputField.style.display = "flex";
  }
};
export var addHotjarToIframeAttribute = function addHotjarToIframeAttribute() {
  var iframe = document.getElementById("web-messenger-container");
  if (iframe) {
    iframe.setAttribute("data-hj-allow-iframe", "true");
  }
};
var shouldDisplayLanguageTopBanner = function shouldDisplayLanguageTopBanner() {
  var chatAvailableLanguages = getSettingHelpCenterChatAvailableLocales().map(function (locale) {
    return locale.language;
  });
  return !chatAvailableLanguages.includes(browserLevelLanguage());
};
export var displayTopBanner = function displayTopBanner(strictLocalize) {
  var topBanner = getIframeElementFromSelector(".intro-pane");
  if (topBanner && shouldDisplayLanguageTopBanner()) {
    topBanner.style.backgroundColor = Core.surface.info;
    topBanner.style.padding = getSpacing("2x");
    topBanner.textContent = strictLocalize({
      id: "TqxhD1",
      defaultMessage: [{
        "type": 0,
        "value": "Chat support is currently available in English"
      }]
    });
  }
};
export var hideTopBanner = function hideTopBanner() {
  var topBanner = getIframeElementFromSelector(".intro-pane");
  if (topBanner) {
    topBanner.style.display = "none";
  }
};